import { useContext } from "react";
import { Layer, Source } from "react-map-gl/mapbox-legacy";
import {
  CLUSTER_CIRCLE_RADIUS,
  CLUSTER_COUNT_DISPLAY,
} from "common/utils/maps/index";
import { textHaloColor } from "common-client/utils/mapLayers";
import { colors } from "../../../stitches.config";
import { LayerContext } from ".";
import { group, SAVED_VIEW_MIN_ZOOM } from "./savedViews";

export const viewsClusterSourceId = "saved-views-cluster-source";
export const viewsClusterLayerId = "saved-views-cluster";

const CLUSTER_MIN_ZOOM = 10;

const SavedViewsClusterLayer = ({
  savedViewIds,
}: {
  savedViewIds: Array<string>;
}) => {
  const { visibleLayerIdsForGroup } = useContext(LayerContext);
  const isLayerVisible = visibleLayerIdsForGroup(group).length > 0;

  const viewTiles = [
    `${
      window.env.APPLICATION_URL
    }/api/tiles/views-cluster/{z}/{x}/{y}?savedViewIds=${savedViewIds.join(
      ",",
    )}`,
  ];

  return (
    <Source
      id={viewsClusterSourceId}
      tiles={viewTiles}
      type="vector"
      maxzoom={SAVED_VIEW_MIN_ZOOM}
      minzoom={CLUSTER_MIN_ZOOM}
    >
      <Layer
        id={viewsClusterLayerId}
        type="circle"
        source-layer="src"
        layout={{
          visibility: isLayerVisible ? "visible" : "none",
        }}
        paint={{
          "circle-radius": CLUSTER_CIRCLE_RADIUS,
          "circle-opacity": 1,
          "circle-color": colors.grey800.value,
          "circle-stroke-width": 2,
          "circle-stroke-opacity": 0.4,
          "circle-stroke-color": colors.grey800.value,
        }}
        maxzoom={SAVED_VIEW_MIN_ZOOM}
        minzoom={CLUSTER_MIN_ZOOM}
      />

      <Layer
        id={`${viewsClusterLayerId}-label`}
        type="symbol"
        source-layer="src"
        layout={{
          visibility: isLayerVisible ? "visible" : "none",
          "text-field": CLUSTER_COUNT_DISPLAY,
          "text-padding": 10,
          "text-size": 15,
          "text-font": ["DIN Offc Pro Bold", "Arial Unicode MS Regular"],
          "text-allow-overlap": true,
        }}
        maxzoom={SAVED_VIEW_MIN_ZOOM}
        minzoom={CLUSTER_MIN_ZOOM}
        paint={{
          "text-color": colors.contentPrimaryInverted.value,
          "text-halo-color": textHaloColor,
          "text-halo-width": 1,
        }}
      />
    </Source>
  );
};

export default SavedViewsClusterLayer;
